var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65086 3.52043C7.70987 1.62139 8.23896 0.671875 9.03051 0.671875C9.82205 0.671875 10.3511 1.62139 11.4102 3.52043L11.6843 4.0119C11.9852 4.55186 12.1357 4.82184 12.3697 4.99987C12.6037 5.17791 12.8963 5.24394 13.4814 5.376L14.013 5.49636C16.0691 5.96193 17.0964 6.19429 17.3413 6.98082C17.5854 7.76651 16.8849 8.58648 15.4832 10.2256L15.1205 10.6493C14.7226 11.1149 14.5228 11.3481 14.4334 11.6356C14.344 11.924 14.3741 12.2349 14.4342 12.856L14.4894 13.4218C14.7009 15.6092 14.807 16.7025 14.1668 17.1881C13.5265 17.6746 12.5636 17.2308 10.6395 16.3448L10.1405 16.1158C9.59387 15.8633 9.32054 15.738 9.03051 15.738C8.74047 15.738 8.46715 15.8633 7.91967 16.1158L7.42234 16.3448C5.4974 17.2308 4.5345 17.6738 3.89508 17.189C3.25399 16.7025 3.36014 15.6092 3.57161 13.4218L3.62678 12.8568C3.68696 12.2349 3.71705 11.924 3.62678 11.6365C3.53818 11.3481 3.33841 11.1149 2.94055 10.6502L2.5778 10.2256C1.17609 8.58731 0.475648 7.76735 0.719715 6.98082C0.964617 6.19429 1.9927 5.96109 4.04888 5.49636L4.58048 5.376C5.16473 5.24394 5.45644 5.17791 5.69131 4.99987C5.92535 4.82184 6.0758 4.55186 6.3767 4.0119L6.65086 3.52043Z",
    fill: "#FCC01C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.13b7fa5d2ec9900b2b314886074d57ca.svg";
export { ForwardRef as ReactComponent };